import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7270dc05"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-section-title" }, "フライングドクター依頼", -1))
const _hoisted_2 = {
  class: "q-mb-lg",
  style: {"padding-top":"36px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sampleform-section-title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "sampleform-section-title" }, [
    /*#__PURE__*/_createTextVNode(" フライングドクター"),
    /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
    /*#__PURE__*/_createTextVNode(" 依頼前のチェックシート ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-caption",
  style: {"padding-left":"8px"}
}, " ※すべての項目の確認後、チェックを入れたら申請書が表示されます。 ", -1))
const _hoisted_5 = { class: "checksheet-box" }
const _hoisted_6 = { class: "row checksheet" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 checksheet__heading" }, "STEP0. 顧客からの用命", -1))
const _hoisted_8 = { class: "col-12 col-sm-5 checksheet__checkbox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-7 checksheet__txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "q-mb-xs text-bold" }, "【備考】"),
  /*#__PURE__*/_createTextVNode(" 発生状況と症状を正確に聞き取り、可能な限り再現させて確認する。 ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 checksheet__heading" }, "STEP1. 2時間以上のCETによる診断", -1))
const _hoisted_11 = { class: "col-12 col-sm-5" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 checksheet__checkbox" }
const _hoisted_14 = { class: "col-12 checksheet__checkbox" }
const _hoisted_15 = { class: "col-12 checksheet__checkbox" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-7 checksheet__txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "q-mb-xs text-bold" }, "【備考】"),
  /*#__PURE__*/_createTextVNode(" 速やかに経験が豊富なCETが初期診断を行い、本当に不具合なのか判断する 仕様なのか不具合なのか不明な場合は他の同型車で確認する、または(STEP2)に進みDID-Aに問い合わせる ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 checksheet__heading" }, "STEP2. DID-Aにデータを送信してサポート依頼可能", -1))
const _hoisted_18 = { class: "col-12 col-sm-5 checksheet__checkbox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-7 checksheet__txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "q-mb-xs text-bold" }, "【備考】"),
  /*#__PURE__*/_createElementVNode("span", null, " 2時間以上診断して解決策が不明な場合はDID-Aにサポートを依頼できる")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 checksheet__heading" }, "STEP3. DID-Aの指示に従い診断を進める", -1))
const _hoisted_21 = { class: "col-12 col-sm-5 checksheet__checkbox" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-7 checksheet__txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "q-mb-xs text-bold" }, "【備考】"),
  /*#__PURE__*/_createTextVNode(" DID-Aの指示に対するもれがあると誤った解決方法が提供される ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 checksheet__heading" }, "STEP4. DID-Aにもれなく結果を報告する", -1))
const _hoisted_24 = { class: "col-12 col-sm-5 checksheet__checkbox" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-sm-7 checksheet__txt\" data-v-7270dc05><p class=\"q-mb-xs text-bold\" data-v-7270dc05>【備考】</p> DID-Aに正しい報告をしないと誤った解決方法が提供される </div><div class=\"col-12 checksheet__heading\" data-v-7270dc05>STEP5. DID-Aから解決方法が提供される</div><div class=\"col-12 checksheet__heading\" data-v-7270dc05>STEP6. 解決策を適用</div><div class=\"col-12 checksheet__txt\" data-v-7270dc05><p class=\"q-mb-xs text-bold\" data-v-7270dc05>【備考】</p> 7日以内に結果を報告する </div><div class=\"col-12 checksheet__heading\" data-v-7270dc05>STEP7. 症状が改善しない</div>", 5)
const _hoisted_30 = { class: "col-12 col-sm-5 checksheet__checkbox" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-7 checksheet__txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "q-mb-xs text-bold" }, "【備考】"),
  /*#__PURE__*/_createTextVNode(" フライングドクターを要請する場合は出張点検依頼書を作成提出する ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"border":"1px solid #333"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-bold q-py-xs",
    style: {"font-size":"1.1rem","border-bottom":"1px solid #333","background":"repeating-linear-gradient(-45deg, #f0f8ff 3px, #e9f4ff 3px 7px)"}
  }, " 依頼をする前に "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-bold" }, " 他(拠点)のメカニックにより0からの再診断を行ってください、多くの問題は別の視点から見ることで解決します。 "),
  /*#__PURE__*/_createElementVNode("p", null, "プジョー福山・宮崎・鹿児島でも同様の症状。情報共有中。")
], -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "q-mb-lg q-mt-xl" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sampleform-section-title-wrap" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "sampleform-section-title" }, [
    /*#__PURE__*/_createTextVNode("フライングドクター申請書"),
    /*#__PURE__*/_createElementVNode("br", { class: "pc-none" }),
    /*#__PURE__*/_createTextVNode("及び報告書")
  ])
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "1. 申請者の基本情報を記入してください。", -1))
const _hoisted_37 = { class: "text-center q-mb-xl form-item" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-12 col-sm-6 form-item__wrap" }
const _hoisted_40 = { class: "form-item__label" }
const _hoisted_41 = { for: "name" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("申請者の氏名")
const _hoisted_43 = { class: "form-item__input" }
const _hoisted_44 = { class: "form-item__label" }
const _hoisted_45 = { for: "name" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("実施希望日")
const _hoisted_47 = { class: "form-item__input" }
const _hoisted_48 = { class: "col-12 col-sm-6" }
const _hoisted_49 = { class: "form-item__label" }
const _hoisted_50 = { for: "name" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("ディーラー名")
const _hoisted_52 = { class: "form-item__input" }
const _hoisted_53 = { class: "form-item__label" }
const _hoisted_54 = { for: "name" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("実施希望日")
const _hoisted_56 = { class: "form-item__input" }
const _hoisted_57 = { class: "q-mb-lg" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "2. 車両情報を記入してください。", -1))
const _hoisted_59 = { class: "text-center q-mb-xl form-item" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-12 col-sm-6 form-item__wrap" }
const _hoisted_62 = { class: "form-item__label" }
const _hoisted_63 = { for: "name" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("モデル")
const _hoisted_65 = { class: "form-item__input" }
const _hoisted_66 = { class: "form-item__label" }
const _hoisted_67 = { for: "name" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("総走行距離")
const _hoisted_69 = { class: "form-item__input" }
const _hoisted_70 = { class: "col-12 col-sm-6" }
const _hoisted_71 = { class: "form-item__label" }
const _hoisted_72 = { for: "name" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode("VIN")
const _hoisted_74 = { class: "form-item__input" }
const _hoisted_75 = { class: "form-item__label" }
const _hoisted_76 = { for: "name" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode("初年度登録")
const _hoisted_78 = { class: "form-item__input" }
const _hoisted_79 = { class: "q-mb-lg" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "3. 診断記録を記入してください。", -1))
const _hoisted_81 = { class: "text-center q-mb-xl form-item" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-12" }
const _hoisted_84 = { class: "form-item__label" }
const _hoisted_85 = { for: "name" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("ヘルプデスクチケット取得")
const _hoisted_87 = { class: "form-item__input" }
const _hoisted_88 = { class: "form-item__label" }
const _hoisted_89 = { for: "name" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode("E-Diag 実施状況")
const _hoisted_91 = { class: "form-item__input" }
const _hoisted_92 = { class: "q-mb-lg" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "4. 申請内容を記入してください。", -1))
const _hoisted_94 = { class: "text-center q-mb-xl form-item" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-12" }
const _hoisted_97 = { class: "form-item__label" }
const _hoisted_98 = { for: "name" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("申請内容")
const _hoisted_100 = { class: "form-item__input" }
const _hoisted_101 = { class: "q-mb-lg" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "5. 申請に至るまでの経緯を記入してください。", -1))
const _hoisted_103 = { class: "form-item" }
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "col-12 col-sm-4 form-item__wrap" }
const _hoisted_106 = { class: "form-item__label" }
const _hoisted_107 = { for: "name" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("入庫日")
const _hoisted_109 = { class: "form-item__input" }
const _hoisted_110 = { class: "form-item__label" }
const _hoisted_111 = { for: "name" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode("走行距離")
const _hoisted_113 = { class: "form-item__input" }
const _hoisted_114 = { class: "col-12 col-sm-8" }
const _hoisted_115 = { class: "form-item__label" }
const _hoisted_116 = { for: "name" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode("症状や修理内容等")
const _hoisted_118 = { class: "form-item__input" }
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-12 col-sm-4 form-item__wrap" }
const _hoisted_121 = { class: "form-item__label" }
const _hoisted_122 = { for: "name" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode("入庫日")
const _hoisted_124 = { class: "form-item__input" }
const _hoisted_125 = { class: "form-item__label" }
const _hoisted_126 = { for: "name" }
const _hoisted_127 = /*#__PURE__*/_createTextVNode("走行距離")
const _hoisted_128 = { class: "form-item__input" }
const _hoisted_129 = { class: "col-12 col-sm-8" }
const _hoisted_130 = { class: "form-item__label" }
const _hoisted_131 = { for: "name" }
const _hoisted_132 = /*#__PURE__*/_createTextVNode("症状や修理内容等")
const _hoisted_133 = { class: "form-item__input" }
const _hoisted_134 = { class: "q-mb-lg" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "6. 現地作業内容を記入してください。", -1))
const _hoisted_136 = { class: "form-item" }
const _hoisted_137 = { class: "row" }
const _hoisted_138 = { class: "col-12 col-sm-4 form-item__wrap" }
const _hoisted_139 = { class: "form-item__label" }
const _hoisted_140 = { for: "name" }
const _hoisted_141 = /*#__PURE__*/_createTextVNode("入庫日")
const _hoisted_142 = { class: "form-item__input" }
const _hoisted_143 = { class: "form-item__label" }
const _hoisted_144 = { for: "name" }
const _hoisted_145 = /*#__PURE__*/_createTextVNode("走行距離")
const _hoisted_146 = { class: "form-item__input" }
const _hoisted_147 = { class: "col-12 col-sm-8" }
const _hoisted_148 = { class: "form-item__label" }
const _hoisted_149 = { for: "name" }
const _hoisted_150 = /*#__PURE__*/_createTextVNode("実施内容")
const _hoisted_151 = { class: "form-item__input" }
const _hoisted_152 = { class: "row" }
const _hoisted_153 = { class: "col-12 col-sm-4 form-item__wrap" }
const _hoisted_154 = { class: "form-item__label" }
const _hoisted_155 = { for: "name" }
const _hoisted_156 = /*#__PURE__*/_createTextVNode("入庫日")
const _hoisted_157 = { class: "form-item__input" }
const _hoisted_158 = { class: "form-item__label" }
const _hoisted_159 = { for: "name" }
const _hoisted_160 = /*#__PURE__*/_createTextVNode("走行距離")
const _hoisted_161 = { class: "form-item__input" }
const _hoisted_162 = { class: "col-12 col-sm-8" }
const _hoisted_163 = { class: "form-item__label" }
const _hoisted_164 = { for: "name" }
const _hoisted_165 = /*#__PURE__*/_createTextVNode("実施内容")
const _hoisted_166 = { class: "form-item__input" }
const _hoisted_167 = { class: "q-mb-lg" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-bold q-mb-sm",
  style: {"font-size":"1.1rem"}
}, "7. 結果報告を記入してください。", -1))
const _hoisted_169 = { class: "row form-item" }
const _hoisted_170 = { class: "col-12" }
const _hoisted_171 = { class: "form-item__label" }
const _hoisted_172 = { for: "name" }
const _hoisted_173 = /*#__PURE__*/_createTextVNode("結果報告")
const _hoisted_174 = { class: "form-item__input" }
const _hoisted_175 = { class: "row justify-center q-mt-lg q-pb-sm" }

import { reactive } from 'vue'

// TODO: データの持ち方は仮

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const answer = reactive({
  first: {
    name: '',
    day: '',
    dealer: '',
    manager: '',
  },
  second: {
    model: '',
    mileage: '',
    vin: '',
    firstYear: '',
  },
  third: {
    a: null,
    b: null,
  },
  four: '',
  five: {
    a: {
      date: '',
      mileage: '',
      text: '',
    },
    b: {
      date: '',
      mileage: '',
      text: '',
    },
  },
  six: {
    a: {
      date: '',
      mileage: '',
      text: '',
    },
    b: {
      date: '',
      mileage: '',
      text: '',
    },
  },
  seven: '',
})

const checkData = reactive({
  step0: false,
  step1: {
    one: false,
    two: false,
    three: false,
  },
  step2: false,
  step3: false,
  step4: false,
  step5: false,
  step6: false,
  step7: false,
})

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "text-bold",
        style: _normalizeStyle([{"padding-left":"8px"}, _ctx.$q.screen.lt.sm ? 'font-size: 16px;' : 'font-size: 1.1rem;'])
      }, " すべての項目が確認できているかをチェックしてください。 ", 4),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_checkbox, {
              style: {"width":"100%"},
              size: _ctx.$q.screen.lt.sm ? 'xs' : '',
              modelValue: _unref(checkData).step0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(checkData).step0) = $event)),
              label: "症状の再現"
            }, null, 8, ["size", "modelValue"])
          ]),
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_q_checkbox, {
                  style: {"width":"100%"},
                  size: _ctx.$q.screen.lt.sm ? 'xs' : '',
                  modelValue: _unref(checkData).step1.one,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(checkData).step1.one) = $event)),
                  label: "2時間以上診断を行った"
                }, null, 8, ["size", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_q_checkbox, {
                  style: {"width":"100%"},
                  size: _ctx.$q.screen.lt.sm ? 'xs' : '',
                  modelValue: _unref(checkData).step1.two,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(checkData).step1.two) = $event)),
                  label: "社外品を完全に取り外して診断した"
                }, null, 8, ["size", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_q_checkbox, {
                  style: {"width":"100%"},
                  size: _ctx.$q.screen.lt.sm ? 'xs' : '',
                  modelValue: _unref(checkData).step1.three,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(checkData).step1.three) = $event)),
                  label: "仕様や使い方の問題ではない"
                }, null, 8, ["size", "modelValue"])
              ])
            ])
          ]),
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_q_checkbox, {
              style: {"width":"100%"},
              size: _ctx.$q.screen.lt.sm ? 'xs' : '',
              modelValue: _unref(checkData).step2,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(checkData).step2) = $event)),
              label: "送信データに不備が無い"
            }, null, 8, ["size", "modelValue"])
          ]),
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_q_checkbox, {
              style: {"width":"100%"},
              size: _ctx.$q.screen.lt.sm ? 'xs' : '',
              modelValue: _unref(checkData).step3,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(checkData).step3) = $event)),
              label: "DID-Aの指示通りの診断を行った"
            }, null, 8, ["size", "modelValue"])
          ]),
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_q_checkbox, {
              style: {"width":"100%"},
              size: _ctx.$q.screen.lt.sm ? 'xs' : '',
              modelValue: _unref(checkData).step4,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(checkData).step4) = $event)),
              label: "DID-Aの指示に対して正確な報告を行った"
            }, null, 8, ["size", "modelValue"])
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_q_checkbox, {
              style: {"width":"100%"},
              size: _ctx.$q.screen.lt.sm ? 'xs' : '',
              modelValue: _unref(checkData).step7,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(checkData).step7) = $event)),
              label: "結果をDID-Aに報告した"
            }, null, 8, ["size", "modelValue"])
          ]),
          _hoisted_31
        ])
      ])
    ]),
    _hoisted_32,
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (
          _unref(checkData).step0 === true &&
          _unref(checkData).step1.one === true &&
          _unref(checkData).step1.two === true &&
          _unref(checkData).step1.three === true &&
          _unref(checkData).step2 === true &&
          _unref(checkData).step3 === true &&
          _unref(checkData).step4 === true &&
          _unref(checkData).step7 === true
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("label", _hoisted_41, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_42
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_q_input, {
                          label: "申請者の氏名",
                          id: "name",
                          placeholder: "田中  太郎",
                          "stack-label": "",
                          outlined: "",
                          type: "text",
                          modelValue: _unref(answer).first.name,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(answer).first.name) = $event)),
                          dense: "",
                          class: "q-mb-sm"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("label", _hoisted_45, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_46
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "実施希望日",
                          type: "date",
                          modelValue: _unref(answer).first.day,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(answer).first.day) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_51
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "ディーラー名",
                          type: "text",
                          modelValue: _unref(answer).first.dealer,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(answer).first.dealer) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_55
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          placeholder: "田中  太郎",
                          "stack-label": "",
                          label: "販社担当者名",
                          type: "text",
                          modelValue: _unref(answer).first.manager,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(answer).first.manager) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_64
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "モデル",
                          type: "text",
                          modelValue: _unref(answer).second.model,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(answer).second.model) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("label", _hoisted_67, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_68
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "総走行距離",
                          suffix: "Km",
                          type: "text",
                          modelValue: _unref(answer).second.mileage,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(answer).second.mileage) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("label", _hoisted_72, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_73
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "VIN",
                          type: "text",
                          modelValue: _unref(answer).second.vin,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(answer).second.vin) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("label", _hoisted_76, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_77
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "初年度登録",
                          type: "text",
                          modelValue: _unref(answer).second.firstYear,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(answer).second.firstYear) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("label", _hoisted_85, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_86
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "ヘルプデスクチケット取得",
                          type: "text",
                          modelValue: _unref(answer).third.a,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(answer).third.a) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("label", _hoisted_89, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_90
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "E-Diag 実施状況",
                          type: "text",
                          modelValue: _unref(answer).third.b,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(answer).third.b) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("label", _hoisted_98, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "必須",
                            color: "negative"
                          }),
                          _hoisted_99
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(_component_q_input, {
                          outlined: "",
                          label: "申請内容",
                          type: "textarea",
                          autogrow: "",
                          dense: "",
                          "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                          modelValue: _unref(answer).four,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(answer).four) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_101, [
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("label", _hoisted_107, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_108
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_109, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "入庫日",
                          type: "date",
                          modelValue: _unref(answer).five.a.date,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(answer).five.a.date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("label", _hoisted_111, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_112
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_113, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "走行距離",
                          suffix: "Km",
                          type: "text",
                          modelValue: _unref(answer).five.a.mileage,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(answer).five.a.mileage) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("label", _hoisted_116, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_117
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        _createVNode(_component_q_input, {
                          label: "症状や修理内容等",
                          type: "textarea",
                          autogrow: "",
                          outlined: "",
                          dense: "",
                          "input-style": "min-height: calc(9px + 18px * 6 + 6px)",
                          modelValue: _unref(answer).five.a.text,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(answer).five.a.text) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("label", _hoisted_122, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_123
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_124, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "入庫日",
                          type: "date",
                          modelValue: _unref(answer).five.b.date,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(answer).five.b.date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("label", _hoisted_126, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_127
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "走行距離",
                          suffix: "Km",
                          type: "text",
                          modelValue: _unref(answer).five.b.mileage,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(answer).five.b.mileage) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("label", _hoisted_131, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_132
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_133, [
                        _createVNode(_component_q_input, {
                          label: "症状や修理内容等",
                          type: "textarea",
                          autogrow: "",
                          outlined: "",
                          dense: "",
                          "input-style": "min-height: calc(9px + 18px * 7 + 6px)",
                          modelValue: _unref(answer).five.b.text,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(answer).five.b.text) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _hoisted_135,
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("label", _hoisted_140, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_141
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_142, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "入庫日",
                          type: "date",
                          modelValue: _unref(answer).six.a.date,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(answer).six.a.date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("label", _hoisted_144, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_145
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_146, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "走行距離",
                          suffix: "Km",
                          type: "text",
                          modelValue: _unref(answer).six.a.mileage,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(answer).six.a.mileage) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("label", _hoisted_149, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_150
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_151, [
                        _createVNode(_component_q_input, {
                          label: "実施内容",
                          type: "textarea",
                          autogrow: "",
                          outlined: "",
                          dense: "",
                          "input-style": "min-height: calc(9px + 18px * 7 + 6px)",
                          modelValue: _unref(answer).six.a.text,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(answer).six.a.text) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("label", _hoisted_155, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_156
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_157, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          class: "q-mb-sm",
                          outlined: "",
                          "stack-label": "",
                          label: "入庫日",
                          type: "date",
                          modelValue: _unref(answer).six.b.date,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(answer).six.b.date) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_158, [
                        _createElementVNode("label", _hoisted_159, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_160
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_161, [
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "stack-label": "",
                          label: "走行距離",
                          suffix: "Km",
                          type: "text",
                          modelValue: _unref(answer).six.b.mileage,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(answer).six.b.mileage) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("label", _hoisted_164, [
                          _createVNode(_component_q_badge, {
                            class: "q-mr-sm",
                            label: "任意",
                            color: "primary"
                          }),
                          _hoisted_165
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_166, [
                        _createVNode(_component_q_input, {
                          label: "実施内容",
                          type: "textarea",
                          autogrow: "",
                          outlined: "",
                          dense: "",
                          "input-style": "min-height: calc(9px + 18px * 7 + 6px)",
                          modelValue: _unref(answer).six.b.text,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(answer).six.b.text) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_167, [
                _hoisted_168,
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("div", _hoisted_170, [
                    _createElementVNode("div", _hoisted_171, [
                      _createElementVNode("label", _hoisted_172, [
                        _createVNode(_component_q_badge, {
                          class: "q-mr-sm",
                          label: "必須",
                          color: "negative"
                        }),
                        _hoisted_173
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, [
                      _createVNode(_component_q_input, {
                        label: "結果報告",
                        type: "textarea",
                        autogrow: "",
                        outlined: "",
                        dense: "",
                        "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                        modelValue: _unref(answer).seven,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(answer).seven) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_175, [
                _createVNode(_component_q_btn, {
                  style: {"max-width":"357px","width":"100%"},
                  unelevated: "",
                  color: "primary",
                  label: "回答を完了する"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})